/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Pump_CooldownInputs */

const vi_error_irrigation_pump_cooldown = /** @type {(inputs: Error_Irrigation_Pump_CooldownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bộ tưới này vừa nhận lệnh chưa đầy 1 phút. Chờ đủ 1 phút rồi mới bật lại để bảo vệ máy bơm.`)
};

/**

* @param {Error_Irrigation_Pump_CooldownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_pump_cooldown = /** @type {((inputs?: Error_Irrigation_Pump_CooldownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Pump_CooldownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_pump_cooldown(inputs)
});